export default __webpack_public_path__ + "static/media/d56be3b7e9cbd3b13607861b7e918be01581600729379.6bc33cf6.webp";